module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (208).9602240e.jpg";